import axios from "axios";
import moment from "moment";
import { getFinalKcalAndPercentage } from "../../../helpers/mealsHelper";
import i18n from "../../../i18n";

// Constants
const SET_CHART_DATA = "SET_CHART_DATA";

//Acessors
const getTotalItems = (state) => state?.totalItems;
const getEntries = (state) => state?.entries;

// Default State
const defaultState = {
  entries: [],
  totalItems: null,
};

//Reducer
export const studyLineChartReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_CHART_DATA: {
      const { chartData } = action;
      return Object.assign({}, state, {
        entries: chartData.total,
        totalItems: chartData.totalEntries,
      });
    }
    default:
      return state;
  }
};

const fetchLineChartData =
  (startDate, endDate, participantId = null) =>
  (dispatch) => {
    const params = {
      limit: 9999,
      StartDate: startDate,
      EndDate: endDate,
    };

    if (participantId) {
      params.ParticipantId = participantId;
    }

    return axios
      .get("/api/diet/userinfo/entries", { params })
      .then(({ data: { entries } }) => {
        dispatch({
          type: SET_CHART_DATA,
          chartData: parseChartData(entries, startDate, endDate),
        });
        return Promise.resolve("Got data latest meal data for you.");
      })
      .catch(() => {
        return Promise.reject(i18n.t("errorText.dietDiary.entries.get"));
      });
  };

const getDates = (startDate, endDate) => {
  const dateArray = [];
  let currentDate = moment(startDate);
  while (currentDate <= endDate) {
    dateArray.push(moment(currentDate).format("YYYY-MM-DD"));
    currentDate = moment(currentDate).add(1, "d");
  }
  return dateArray;
};

const parseChartData = (data, startDate, endDate) => {
  const { total, totalEntries } = data;
  const formattedData = [];
  if (total && totalEntries) {
    total.forEach((entry) => {
      const { mealDate, mealJson, completed } = entry;
      const mDate = moment(mealDate).format("YYYY/MM/DD");
      const meals = JSON.parse(mealJson);
      const mealObj = {
        calories: { ...meals.aboutMeal.Calories },
        protein: { ...meals.aboutMeal.Protein },
        carbohydrates: { ...meals.aboutMeal.Carbs },
        fats: { ...meals.aboutMeal.Fats },
        sugars: { ...meals.aboutMeal.Sugars },
        isCompleted: completed,
      };
      const dayObj = {
        date: mDate,
      };
      const dateAtIndex = formattedData.findIndex((d) => d.date === mDate);
      if (dateAtIndex >= 0) {
        formattedData[dateAtIndex].meals.push(mealObj);
        const mealDaySum = mealsToDay(formattedData[dateAtIndex].meals);
        formattedData[dateAtIndex].calories = mealDaySum.calories;
        formattedData[dateAtIndex].protein = mealDaySum.protein;
        formattedData[dateAtIndex].carbohydrates = mealDaySum.carbohydrates;
        formattedData[dateAtIndex].sugars = mealDaySum.sugars;
        formattedData[dateAtIndex].fats = mealDaySum.fats;
      } else {
        dayObj.meals = [mealObj];
        dayObj.calories = mealObj.calories;
        dayObj.protein = mealObj.protein;
        dayObj.carbohydrates = mealObj.carbohydrates;
        dayObj.sugars = mealObj.sugars;
        dayObj.fats = mealObj.fats;
        formattedData.push(dayObj);
      }
    });
  }

  const kcalObj = getFinalKcalAndPercentage(formattedData);

  const dateRange = getDates(new Date(startDate), new Date(endDate));
  const emptyData = [];
  const defaultData = {
    percentage: 0,
    value: 0,
    unit: "g",
  };
  dateRange.forEach(function (date) {
    const emptyDayData = {
      meals: [],
      protein: defaultData,
      calories: defaultData,
      carbohydrates: defaultData,
      sugars: defaultData,
      fats: defaultData,
      date: moment(date).format("YYYY/MM/DD"),
    };
    emptyData.push(emptyDayData);
  });
  // After getting all the dates between startDate and endDate, fill each day with defaultData
  // and then replace each non empty day with respective meal data by date
  const dateRangeData = Object.values(
    [].concat(emptyData, kcalObj).reduce((r, c) => {
      r[c.date] = Object.assign(r[c.date] || {}, c);
      return r;
    }, {})
  );

  return { total: dateRangeData, totalEntries };
};

const mealsToDay = (array = []) => {
  const tempData = array.reduce((p, c) => {
    return {
      calories: {
        percentage: p.calories.percentage + c.calories.percentage,
        value: p.calories.value + c.calories.value,
        unit: c.calories.unit,
      },
      protein: {
        percentage: p.protein.percentage + c.protein.percentage,
        value: p.protein.value + c.protein.value,
        unit: c.protein.unit,
      },
      carbohydrates: {
        percentage: p.carbohydrates.percentage + c.carbohydrates.percentage,
        value: p.carbohydrates.value + c.carbohydrates.value,
        unit: c.carbohydrates.unit,
      },
      fats: {
        percentage: p.fats.percentage + c.fats.percentage,
        value: p.fats.value + c.fats.value,
        unit: c.fats.unit,
      },
      sugars: {
        value: p.sugars.value + c.sugars.value,
        unit: c.sugars.unit,
      },
    };
  });

  return tempData;
};

// Maps
export const mapDispatchToProps = {
  fetchLineChartData,
};

export const mapStateToProps = (state) => {
  return {
    totalItems: getTotalItems(state),
    entries: getEntries(state),
  };
};
